import React, {Component, useEffect, useState} from 'react';
import {
    List,
    TextField,
    FunctionField,
    BooleanInput,
    Filter,
    TextInput,
    SelectInput,
    Pagination,
    downloadCSV,
    AutocompleteArrayInput, SearchInput, NumberInput, Empty
} from 'react-admin';
import {parse} from 'json2csv';
import {Link} from 'react-router-dom';
import {Datagrid, useListContext, useShowContext} from 'react-admin';
import i18next from 'i18next';
import {IirsaCountriesService} from '~/../config/services/iirsa_countries.service';
import {statusChoices, fundingSourcesChoices, sectorChoices} from '~constants/fieldGroups';
import {getEtapas} from '~services/EtapaService';

import CustomDatagrid from '../components/CustomDatagrid';
import NumberBetweenInput from '../components/NumberBetweenInput';
import NestedSelectInput from '../components/NestedSelectInput';
import ProjectsData from '../components/ProjectsData';
import PublicationBadge from '~components/PublicationBadge';

import styles from './styles.module.scss';
import Breadcrumb from "~components/Breadcrumb";
import CustomList from "../components/CustomList";
import {RouteProps, useParams} from "react-router";
import {getRouteProjects, Route} from "~services/RoutesService";
import {RA_LIST_CUSTOM_STYLE} from "~screens/Dashboard/screens/ProjectsIIRSA/constants";
import {useSyncStoreToLocation} from "../hooks/useSyncStoreToLocation";
import {stripHtmlTags} from "~utils/textFormatting";
import {getDate} from "~utils/date";
import OldBreadcrumb from "~components/OldBreadcrumb";
import {SectorsService} from "../../../../../../config/services/sectors.service";
import {CustomEmpty} from "~screens/Dashboard/screens/ProjectsIIRSA/components/CustomEmpty";


class ProjectFilter extends Component {
    state = {
        countries: [],
        sectors: [],
        stages: []
    };

    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        const cs = new IirsaCountriesService();
        cs.get_la().then(r => {
            this.setState({countries: r.data});
        });

        const ss = new SectorsService();
        ss.get().then(r => {
            this.setState({sectors: r.data});
        });

        getEtapas().then((r: any) => {
            if (r.ok && r.data) {
                this.setState({stages: r.data});
            }
        });
    }

    render() {
        return (
            <Filter {...this.props}>
                <SearchInput source={'search'} alwaysOn  variant={'outlined'}/>
                <TextInput source="code" label={i18next.t('projects-iirsa:code') as string} variant={'outlined'}/>
                <TextInput source="name" label={i18next.t('projects-iirsa:name') as string} variant={'outlined'}/>

                <NestedSelectInput
                    label={i18next.t('projects-iirsa:sector')}
                    source="sector"
                    fstSource="id"
                    sndSource="id_subsector"
                    fstLabel={i18next.t('projects-iirsa:sector')}
                    sndLabel={i18next.t('projects-iirsa:subsector')}
                    fstChoices={this.state.sectors}
                    // eslint-disable-next-line react/jsx-no-bind
                    getSndChoices={fstValue => [{id: null, name: ''}, ...fstValue.subsectors]}
                    variant={'outlined'}
                />

                {/* <SelectInput
                    source="iirsa_funding_source"
                    choices={fundingSourcesChoices}
                    label={i18next.t('projects-iirsa:fundingSource')}
                    variant={'outlined'}
                /> */}
                <SelectInput source="iirsa_stage" choices={this.state.stages} label={i18next.t('projects-iirsa:stage') as string} variant={'outlined'}/>
                {/* <SelectInput source="iirsa_status" choices={statusChoices} label={i18next.t('projects-iirsa:status')} variant={'outlined'}/> */}
                {/* <SelectInput source="iirsa_sector" choices={this.state.sectors} label={i18next.t('projects-iirsa:sector') as string} variant={'outlined'}/> */}
                {/* <BooleanInput source="accompaniment" label={i18next.t('projects-iirsa:accompaniment')} variant={'outlined'}/> */}

                <AutocompleteArrayInput
                    label={i18next.t('projects-iirsa:countries') as string}
                    source="iirsa_countries"
                    choices={this.state.countries}
                    variant={'outlined'}
                />

                <NumberInput label={i18next.t('projects-iirsa:totalInvestmentMin') as string} source={'iirsa_total_investment_min'} variant={'outlined'}/>
                <NumberInput label={i18next.t('projects-iirsa:totalInvestmentMax') as string} source={'iirsa_total_investment_max'} variant={'outlined'}/>

                {/*<NumberBetweenInput source="iirsa_total_investment" label={i18next.t('projects-iirsa:totalInvestment')}/>*/}
            </Filter>
        );
    }
}

// eslint-disable-next-line react/no-multi-comp
const PostPagination = props => {
    return <Pagination rowsPerPageOptions={[25, 50, 100]}  {...props} />;
};

export const financingChoices = [
    {id: 'public_project', name: 'Público'},
    {id: 'private_project', name: 'Privado'},
    {id: 'mixed_project', name: 'Mixto'}
];

function formatProject(p) {
    const t = (key: string) => i18next.t(`projects-iirsa:${key}`) as string;
    p[t('code')] = p.id;
    p[t('name')] = p.name;
    p[t('exportGoal')] = stripHtmlTags(p.goal);
    p[t('description')] = stripHtmlTags(p.description);
    p[t('countries')] = p.countries;
    p[t('exportScope')] = p.iirsaScope?.name;
    p[t('sector')] = p.iirsaSector.name;
    p[t('subsector')] = p.iirsaSubsector.name;
    p[t('exportProjectType')] = p.iirsaProjectType?.name;
    p[t('stage')] = p.iirsaStage.name;
    p[t('status')] = p.iirsaStatus?.name;
    p[t('exportEndDate')] = p.endDate ? getDate(p.endDate, 'MM/YYYY') : '';
    p[t('exportTotalFinancing')] = p.totalInvestmentFormatted;
    p[t('exportAmbientalLicense')] = p.hasAmbientalLicense ? i18next.t('technicalSheet:yes') as string : i18next.t('technicalSheet:no') as string;
    p[t('exportStudiesState')] = p.iirsaStudiesState?.name;
    p[t('exportStudiesFinished')] = p.studiesFinished ? i18next.t('technicalSheet:yes') as string : i18next.t('technicalSheet:no') as string;
    p[t('exportStudiesAmount')] = p.studiesAmount;
}

const exporter = proj => {
    const t = (key: string) => i18next.t(`projects-iirsa:${key}`) as string;
    const page = proj?.page || proj || [];
    page.forEach(p => {
        formatProject(p);
    });
    const fields = [
        t('code'),
        t('name'),
        t('exportGoal'),
        t('description'),
        t('countries'),
        t('exportScope'),
        t('sector'),
        t('subsector'),
        t('exportProjectType'),
        t('stage'),
        t('status'),
        t('exportEndDate'),
        t('exportTotalFinancing'),
        t('exportAmbientalLicense'),
        t('exportStudiesState'),
        t('exportStudiesFinished'),
        t('exportStudiesAmount'),
    ];
    const formattedCsv = parse(proj, {fields});
    downloadCSV(formattedCsv, 'Proyectos');
};

// eslint-disable-next-line react/no-multi-comp
const ProjectList = (props) => {
        const { id } = useParams();

        useSyncStoreToLocation({
            storeKey: `project_list_filters_${id || 'all'}`,
            sort: {field: 'nombre', order: 'ASC'},
            perPage: 50,
        });

        const [state, setState] = useState<{
            route: Route | undefined;

        }>({
            route: undefined,
        });
        
        useEffect(() => {
            if (!id) {
                setState({...state, route: undefined});
                return;
            }

            getRouteProjects(id).then(route => {
                setState({...state, route: route});
            });
        }, [id]);
        

        const title = state?.route?.name || (i18next.t('projects-iirsa:projects') as string);
        const listPath = `/routes/${id}/projects`;
        const mapPath = `map`;

        const breadcrumb = <OldBreadcrumb title={title} paths={[
            {name: i18next.t('projects-iirsa:start') as string},
            {name: i18next.t('projects-iirsa:projects') as string},
        ]}/>;

        return (
            <CustomList key={`project_custom_list_${id}`} mapPath={mapPath} listPath={listPath} listLabel={i18next.t('projects-iirsa:projects')}
                        chartsPath={'/project-charts'} chartsLabel={i18next.t('projects-iirsa:charts')} title={title}
                        breadcrumb={breadcrumb}
                        {...props}>
                <List
                    key={`project_list_${id}`}
                    {...props}
                    exporter={exporter}
                    storeKey={`project_list_filters_${id || 'all'}`}
                    filters={<ProjectFilter/>}
                    pagination={<PostPagination/>}
                    perPage={50}
                    disableSyncWithLocation={false}
                    filter={{routeId: id}}
                    resource={'projects'}
                    sx={RA_LIST_CUSTOM_STYLE}
                    sort={{field: 'nombre', order: 'ASC'}}
                    emptyWhileLoading={false}
                    empty={<CustomEmpty/>}
                >
                    <CustomDatagrid rowClick="show" bulkActionButtons={false}>
                        <TextField source="code" label={i18next.t('projects-iirsa:code') as string} sortBy={'codigo'}/>
                        <TextField source="name" label={i18next.t('projects-iirsa:name') as string} sortBy={'nombre'}/>
                        <TextField source="countries" label={i18next.t('projects-iirsa:countries') as string} sortBy={'paises_string'}/>
                        <TextField source="iirsaStage.name" label={i18next.t('projects-iirsa:stage') as string} sortBy={'etapa__nombre'}/>
                        <TextField source="iirsaSector.name" label={i18next.t('projects-iirsa:sector') as string} sortBy={'subsector__sector__nombre'}/>
                        <TextField
                            className={styles.textAlignRight}
                            source="totalInvestmentFormatted"
                            label={i18next.t('projects-iirsa:totalInvestment') as string}
                            sortBy={'total_investment'}
                        />
                        <FunctionField
                            label=""
                            render={(record: any) => <PublicationBadge status={record?.publicationStatus}/>}
                        />
                    </CustomDatagrid>
                </List>
            </CustomList>
        );
}


// const mapStateToProps = state => {
//     return {
//         routeId: state.routes.selectedRouteId,
//     }
// };
//
// export default connect(
//     mapStateToProps,
// )(ProjectList);

export default ProjectList;
